<template>
    <div>
        <slot><p><strong>Fahrzeugstandort</strong></p></slot>
        <p class="text-left">
            {{ vehicle.subsidiary.name }}<br>
            {{ vehicle.address.street }} {{ vehicle.address.house_number }}
            <br>
            {{ vehicle.address.postal_code }} {{ vehicle.address.city }}
        </p>
    </div>
</template>

<script>
    export default {
        name: "VehicleAddress",
        props: {
            vehicle: {
                type: Object,
                required: true
            }
        },
        computed: {

        }
    }
</script>

<style scoped>

</style>